module.exports = __webpack_public_path__ + "media/src/javascripts/ienavi-frontend/components/budget-simulator/assets/mvsp-8a49bde07eb034ad228a2c6bdc421349.jpg";